import { render, staticRenderFns } from "./LanguageTab.vue?vue&type=template&id=41b9b346"
import script from "./LanguageTab.vue?vue&type=script&lang=js"
export * from "./LanguageTab.vue?vue&type=script&lang=js"
import style0 from "./LanguageTab.vue?vue&type=style&index=0&id=41b9b346&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports